export default "__VITE_ASSET__DLSYJvbF__"